export const parseJsonIfNecessary = (data: any) => {
  if (typeof data === 'object') {
    return data;
  }
  return JSON.parse(data);
};
